export default __webpack_public_path__ + "static/media/iphone12Floating.fdf9224c.png";